import React from 'react';

import "./assets/scss/themes.scss";

import StorefrontAnalytics from './Components/StorefrontAnalytics';
//imoprt Route
import Route from './Routes/Index';

function App() {
  return (
    <React.Fragment>
      <StorefrontAnalytics />
      <Route />
    </React.Fragment>
  );
}

export default App;
